import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette } from '../../../../theme';

const useHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerWrap: {
      padding: 0,
    },
    header: {
      color: colorsPalette.white,
      fontWeight: 700,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      minHeight: 64,
    },
    activeArrow: {
      transition: 'all .3s',
      color: theme.palette.primary.main,
      '&.arrow-up': {
        transform: 'rotate(180deg)',
      },
    },
  }),
);

export default useHeaderStyles;
